<template>
  <v-container mb-12 mt-5>
    <v-row>
      <v-col sm="3" md="6" offset-lg="0">
        <h1>Records</h1>
        <v-spacer></v-spacer>
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <hr />
    <v-row>
      <v-col>
        <RecordNavigation :filing="filing" :category="category" :folder="folder" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          v-model="selected"
          :single-select="false"
          show-select
          :headers="headers"
          :items="allRecordFiles"
          :items-per-page="5"
          class="elevation-2"
          item-key="name"
          :search="search"
        >

          <template v-slot:[`item.actions`]="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-arrow-down-drop-circle
                </v-icon>
              </template>
              <v-list>
                <v-list-item class="action-item">
                  <v-list-item-title @click="editItem(item)">
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                    Update Details
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="action-item">
                  <v-list-item-title>
                    <v-icon small>
                      mdi-folder-move
                    </v-icon>
                    Move To Folder
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="action-item">
                  <v-list-item-title @click="deleteItem(item.id)">
                    <v-icon small>
                      mdi-trash-can
                    </v-icon>
                    Delete Record
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Update Details</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Name*"
                      v-model="editedItem.name"
                      required
                      hint="Make sure it's easy to remember"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Type*"
                      v-model="editedItem.type"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Title*"
                      v-model="editedItem.title"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Sender*"
                      v-model="editedItem.sender"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Address*"
                      v-model="editedItem.address"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <h3 class="text-center red--text"> {{ errorMessage }} </h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Swal from 'sweetalert2';
import RecordNavigation from "../../components/RecordNavigation";

export default {
  name: "RecordFile",
  components: {
    RecordNavigation,
  },
  data() {
    return {
      singleSelect: false,
      selected: [],
      search: "",
      dialog: false,
      categoryId: this.$route.params.id,
      errorMessage: null,
      filing: {
        id: "",
        title: "",
      },
      category: {
        id: "",
        title: "",
      },
      folder: {
          id: "",
          title: ""
      },
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Type", value: "type" },
        { text: "Title", value: "title" },
        { text: "Sender", value: "sender" },
        { text: "Address", value: "address" },
        { text: "Record Date", value: "nrecord_date" },
        { text: "Actions", value: 'actions', sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        type: '',
        title: '',
        sender: '',
        address: '',
      },
      defaultItem: {
        name: '',
        type: '',
        title: '',
        sender: '',
        address: '',
      },
    };
  },
  methods: {
    ...mapActions(["fetchFiles", "deleteFile"]),
    goTo(id) {
      location.replace(`/records/files/${id}`);
    },
    editItem(item) {
      this.errorMessage = null;
      this.editedIndex = this.allRecordFiles.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close () {
      this.dialog = false;
      this.errorMessage = null;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    async save () {
      if (this.editedIndex > -1) {
        // await this.updateOffice(this.editedItem);
      }
      this.close()
    },
    deleteItem(id) {      
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {

          this.deleteFile(id)
            .then(() => {
              Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
              )
            })
        }
      })
    },
  },
  computed: mapGetters(["allRecordFiles"]),
  async created() {
    let response = await this.fetchFiles(this.categoryId);
    console.log(response);
    this.filing.id = response.record_category.record_filing.id;
    this.filing.title = response.record_category.record_filing.title;
    this.category.id = response.record_category.id;
    this.category.title = response.record_category.title;
    this.folder.id = response.id;
    this.folder.title = response.title;
  },
};
</script>

<style scoped>
  .action-item {
    cursor: pointer;
  }
</style>